import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';
import { environment as env } from '../../environments/environment'

@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
    router: any;
    /**
     * Constructor
     */
    constructor(private _authService: AuthService, private translate : TranslateService)
    {
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        // Clone the request object
        let newReq = req.clone();

        // Request
        //
        // If the access token didn't expire, add the Authorization header.
        // We won't add the Authorization header if the access token expired.
        // This will force the server to return a "401 Unauthorized" response
        // for the protected API routes which our response interceptor will
        // catch and delete the access token from the local storage while logging
        // the user out from the app.
        //console.log(req.headers.get('Authorization') + " header");
        if ( this._authService.access_token
            // We don't use it because our current Bearer token is not AWT compatible.
            // && !AuthUtils.isTokenExpired(this._authService.access_token)
        )
        {
            let headers:HttpHeaders;
            const str = newReq.headers.get('Authorization');
            if (!str?.includes('Basic')) {
                newReq = newReq.clone({
                    headers: newReq.headers.set('Authorization', 'Bearer ' + this._authService.access_token)
                });
            }
        }

        // Manage language
        newReq = this.interceptLanguage(newReq);

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {

                // Catch "401 Unauthorized" responses
                if ( error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403))
                {
                    // Sign out
                    this._authService.signOut();

                    // Reload the app

                    if(error.url != null && (error.url.includes ("auth/sellers/corporative"))){
                        this.router.navigate(['/login'])
                    }
                    else{
                        location.reload();
                    }
                }

                return throwError(error);
            })
        );
    }

    interceptLanguage(req: HttpRequest<any>): any
    {
        // Clone the request object
        let newReq = req.clone();
        // Manage language
        try {
            let accept_lang = 'en-US';
            if(env.language_default.toLowerCase()=='mx'){
                accept_lang = 'es-MX'
            }
            newReq = req.clone({headers: req.headers.set("Accept-Language", accept_lang)});
        } catch (e: any){
            console.log("ERROR: " + e);
        }
        return newReq;
    }
}
